module.exports = __webpack_public_path__ + "img/70.7adae755.png";